<form [formGroup]="form" class="grid grid-cols-12 flex-col gap-10">
    <section class="col-span-12 flex flex-col w-full">
        <span class="text-tertiary-900 text-2xl mb-2">
            Please describe the changes you need to the license, application, or
            file number here.
        </span>

        <mat-form-field class="w-full md:w-8/12 xl:w-4/12" appearance="outline">
            <mat-label>Comments</mat-label>
            <textarea
                matInput
                formControlName="comments"
                rows="6"
                placeholder="Describe what you need..."
                title="Comments"
                maxlength="{{ commentsMaxLength }}"
                [appRegexInput]="
                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                "
                required
            ></textarea>
            <mat-hint align="end">
                {{ form.controls.comments.value?.length || 0 }}/{{
                    commentsMaxLength
                }}
            </mat-hint>
        </mat-form-field>

        <div class="w-full md:w-8/12 xl:w-4/12 mt-1">
            <div class="flex justify-start">
                @if (showSubmitButton) {
                    <button
                        mat-raised-button
                        color="primary"
                        class="w-full"
                        [disabled]="!enableSubmission()"
                        (click)="submitToEwa()"
                    >
                        Submit to EWA
                    </button>
                }
            </div>
        </div>
    </section>
</form>
